import { Page } from '@/components';
import { Flex, Heading, useTableProps } from '@blockanalitica/ui';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';

export default function BuybackActivityPage() {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index'
  });

  return (
    <Page title="Activity">
      <HistoricTabs />
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignContent="center"
        alignItems="center">
        <Heading size="3">Events</Heading>
      </Flex>
      <EventsTable pagination={pagination} sorting={sorting} />
    </Page>
  );
}
